import create from 'zustand';

interface LatestPortfolioData {
  available_lot: number;
  price_average: number;
}

interface VirtualLatestPortfolio {
  isLoading: boolean;
  message: string;
  data: LatestPortfolioData;
  error: string;
}

interface iRealTradingState {
  price: number;
  shares: number;
  stockCode: string;
  latestPortfolio: VirtualLatestPortfolio;
}

interface iRealTradingStore extends iRealTradingState {
  setPrice: (any) => void;
  setShares: (any) => void;
  setStockCode: (any) => void;
  resetOrderData: () => void;
}

const initialState: iRealTradingState = {
  price: 0,
  shares: 0,
  stockCode: '',
  latestPortfolio: {
    isLoading: false,
    message: '',
    data: {
      available_lot: 0,
      price_average: 0,
    },
    error: '',
  },
};

const virtualTradingStore = create<iRealTradingStore>((set) => ({
  ...initialState,
  setPrice: (payload) => {
    set({ price: payload });
  },
  setShares: (payload) => {
    set({ shares: payload });
  },
  setStockCode: (payload) => {
    set({ stockCode: payload });
  },
  resetOrderData: () => {
    set(initialState);
  },
}));

export default virtualTradingStore;
